import { tryLoadPropertyStyles } from '../Global/loadDependecy';
import { TemplatePropertyContainerStyles } from './PropertyContainer.styles'
import type { PropertyContainerData } from './types/PropertyContainer.type'

const t = document.createElement('template')
t.innerHTML = `
  <div class="property-container wa-cluster" part="container">
    <slot name="start"></slot>
    <!-- data-driven items inserted here -->
    <slot name="end"></slot>
  </div>
`
const TemplatePropertyContainer = t

class PropertyContainer extends HTMLElement {
  constructor() {
    super()
    
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplatePropertyContainerStyles.content.cloneNode(true))
    shadow.appendChild(TemplatePropertyContainer.content.cloneNode(true))

    tryLoadPropertyStyles(shadow, 'Property.css');
  }

  connectedCallback() {
    console.log('PropertyContainer connectedCallback')
  }

  static get observedAttributes() {
    return ['data', 'display-mode']
  }

  attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null) {
    if (name === 'display-mode' && newValue) {
      this.toggleLayout(newValue)
    } else if (name === 'data' && newValue) {
      this.renderData(newValue)
    }
  }

  // Layout toggle for #property-container display modes
  private toggleLayout(mode: string) {
    const container = this.shadowRoot?.querySelector('.property-container')
    if (!container) return
    if (mode === 'cluster') {
      container.classList.add('wa-cluster')
      container.classList.remove('wa-grid')
    } else if (mode === 'grid') {
      container.classList.add('wa-grid')
      container.classList.remove('wa-cluster')  
    }
  }

  // rendered data or add your own slotted content
  private renderData(json: string) {
    let parsed: PropertyContainerData | null = null
    try {
      parsed = JSON.parse(json)
    } catch {
      console.warn('PropertyContainer: invalid JSON data')
      return
    }

    // Support nested shape { data: { properties: [...] } } as well
    const maybeNested = (parsed as any)
    if (!parsed?.properties && maybeNested?.data?.properties) {
      parsed = maybeNested.data
    }

    const container = this.shadowRoot?.querySelector('.property-container')
    if (!container) return

    // Remove previously data-driven items (keep any slotted content placeholder)
    Array.from(container.querySelectorAll('[data-generated="true"]')).forEach(el => el.remove())

    if (!parsed?.properties || parsed.properties.length === 0) return

    parsed.properties.forEach(p => {
      const item = document.createElement('ts-property')
      item.setAttribute('name', String(p.name))
      item.setAttribute('value', String(p.value))
      item.setAttribute('container-class', 'property-container wa-cluster')
      item.setAttribute('container-part', 'property-container-item')
      item.setAttribute('data-generated', 'true')
      container.insertBefore(item, container.querySelector('slot[name="end"]')!)
    })
  }
}

customElements.define('ts-propertycontainer', PropertyContainer)